import React from 'react'
import Modal from '@components/Common/Modal'
import { ModalProps } from '@interfaces/Modal'
import TableMotorista from '../Table'
import Button from '@components/Common/Button'

const ModalMotorista: React.FC <ModalProps> = props => {

    return(

        <Modal
            {...props}
            title = "Buscar motorista"
            width = "100%"
        >
            <TableMotorista {...props} />
            <div className='ml-auto mt-4'>
                <Button
                    label="Fechar"
                    onClick={() => props.setOpen(false)}
                />
            </div>
        </Modal>

    )

}

export default ModalMotorista